/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 11:01:09
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-24 14:27:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/AddReview/tools.ts
 */
import { sortSales, sortLocales } from 'src/pages/ProductReview/common';

const _key = '{{+-==-+}}';

const convertSaleToState = (sales = []) => {
  return sales.reduce((pre, now) => {
    const { locales, uuid } = now || {};
    return {
      ...pre,
      ...locales.reduce((obj, cLocale) => {
        const { top, publish, locale, isPrimary } = cLocale || {};
        return {
          ...obj,
          [generateChannelWithLocale({ locale, uuid })]: {
            top,
            publish,
            isPrimary,
          },
        };
      }, {}),
    };
  }, {});
};

const convertStateToSale = ({ channel = {}, _sales }) => {
  const mappedByUuid = Object.keys(channel).reduce((pre, key) => {
    const { uuid, locale } = processChannelWithLocale(key);
    const { top, publish, isPrimary } = channel[key];
    const oriData = _sales.find((i) => i.uuid === uuid);

    if (pre[uuid]) {
      (pre[uuid].locales || []).push({
        top,
        publish,
        isPrimary,
        locale,
      });
      pre[uuid].locales = sortLocales(pre[uuid].locales);
    } else {
      pre[uuid] = {
        ...oriData,
        locales: [
          {
            top,
            publish,
            isPrimary,
            locale,
          },
        ],
      };
    }
    return pre;
  }, {});

  const _re = sortSales(Object.values(mappedByUuid));
  return _re;
};

const getAllKeys = (state) => {
  return Object.keys(state);
};

const getSpecKeys = ({ uuid, state }) => {
  return Object.keys(state).reduce((pre, key) => {
    const { uuid: _uuid } = processChannelWithLocale(key);
    if (_uuid == uuid) {
      return [...pre, key];
    }
    return pre;
  }, []);
};

const getSpecValues = ({ uuid, state }) => {
  return Object.keys(state).reduce((pre, key) => {
    const { uuid: _uuid } = processChannelWithLocale(key);
    if (_uuid == uuid) {
      return { ...pre, [key]: state[key] };
    }
    return pre;
  }, []);
};

const currentSelectedPub = (state) => {
  return Object.keys(state).reduce((pre, now) => {
    const { publish } = state[now];
    if (publish) {
      return [...pre, now];
    }
    return pre;
  }, []);
};

const generateChannelWithLocale = ({ locale, uuid }) => {
  return `${locale}${_key}${uuid}`;
};

const processChannelWithLocale = (id) => {
  const [locale, uuid] = id.split(_key);
  return { locale, uuid };
};

export {
  convertSaleToState,
  generateChannelWithLocale,
  processChannelWithLocale,
  getAllKeys,
  getSpecKeys,
  currentSelectedPub,
  getSpecValues,
  convertStateToSale,
};
